import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { create } from 'zustand';

interface PageClientContext {
  pathname: string;
  clientId?: string;
  clientName?: string;
}

export const usePageClientContext = create<PageClientContext>(() => ({ pathname: '' }));

export function usePublishPageClient(clientId?: string, clientName?: string) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!clientId || !clientName) return;
    const context = { pathname, clientId, clientName };
    usePageClientContext.setState(context, true);
    return () => {
      if (usePageClientContext.getState() === context) {
        usePageClientContext.setState({ pathname: '' }, true);
      }
    };
  }, [pathname, clientId, clientName]);
}
